//JSHint ignores this file, you edit it, you jshint it!!
$(function () {
	timeZoneSelector.init();
});

var timeZoneSelector = function ($) {
	var $existingMerchantState, $merchantTimeZoneId, $merchantCountry, $merchantState;

	var rebuildList = function ($list, data, selectedValue) {
		$list.empty();
		var option;
		if (data) {
			$list.attr("disabled", false);
			var options = [];
			for (var d in data) {
				option = '<option value="' + d + '"';
				if (d === "--" || d === "") {
					option = option + ' disabled="true" ';
				}

				if (d === selectedValue) {
					option = option + ' selected="true" ';
				}

				option = option + '>' + data[d].name + '</option>';
				options.push(option);
			}

			$list.append($(options.join(' ')));
		} else {
			$list.attr("disabled", true);
			option = $("<option />").attr("value", "").html("N/A");
			$list.append(option);
		}
	};

	var getSelectedOption = function (e) {
		return e.attr("type") == "hidden" ? e.val() : e.find("option:selected").val();
	}

	var getCurrentTimeZoneById = function(currentTimeZoneId) {
		for (var country in statesTimeZones.timeZonesByCountry) {
			for (var tz in statesTimeZones.timeZonesByCountry[country]) {
				if (tz === currentTimeZoneId) {
					return statesTimeZones.timeZonesByCountry[country][tz];
				}
			}
		}

		return null;
	}

	var init = function () {
		$merchantTimeZoneId = $(".merchant-timezone-id");
		$merchantCountry = $(".merchant-country");
		$merchantState = $(".merchant-state");

		var pushpayerCountriesFlag = $merchantCountry.attr("data-pp-pushpayer-countries") === "True";
		var firstTime = true;

		$merchantCountry.on("change", null, function () {
			var existingMerchantStateValue, currentMerchantTimeZoneId;
			var selectedCountry = getSelectedOption($(this));
			var states = statesTimeZones.statesByCountry[selectedCountry];
			var timeZones = statesTimeZones.timeZonesByCountry[selectedCountry];


			$existingMerchantState = $(".existing-merchant-state");

			var tzs = {};
			tzs[""] = { name: "Please Select..." };

			for (var key in timeZones) {
				if (timeZones.hasOwnProperty(key)) {
					tzs[key] = timeZones[key];
				}
			}

			if (pushpayerCountriesFlag) {
				//Unselectable options, the '--' option seperates the timezones of the currently selected country from the rest
				tzs["--"] = { name: "--" };

				for (var country in statesTimeZones.timeZonesByCountry) {
					if (country !== selectedCountry && country !== "Unspecified") {
						for (var tz in statesTimeZones.timeZonesByCountry[country]) {
							tzs[tz] = statesTimeZones.timeZonesByCountry[country][tz];
						}
					}
				}
			}

			if ($existingMerchantState.length) {
				existingMerchantStateValue = $existingMerchantState.val();
			}

			if (firstTime) {
				firstTime = false;
				currentMerchantTimeZoneId = $(".existing-merchant-timezone-id").val();

				if (!tzs[currentMerchantTimeZoneId]) {
					// If not add it to the list
					var currentTimezone = getCurrentTimeZoneById(currentMerchantTimeZoneId);
					if (currentTimezone) {
						tzs[currentMerchantTimeZoneId] = currentTimezone;
					}
				}
			}
			else {
				// Default to 'Please Select...'
				currentMerchantTimeZoneId = "";
			}

			rebuildList($merchantState, states, existingMerchantStateValue);
			rebuildList($merchantTimeZoneId, tzs, currentMerchantTimeZoneId);
		});

		// States are not 1:1 with time zones

		$merchantCountry.trigger("change");
	};

	return { init: init };
}(jQuery);
